
import { createSlice } from '@reduxjs/toolkit';

export const RmsActiveAlarmSlice = createSlice({
    name: 'rmsActiveAlarmSlice',
    initialState: {
        loading: false,
        data: {

        },
        alarms:[],
        error: false,
    },
    reducers: {
        RMS_ACTIVE_ALARM_FETCH_START: (state) => {
            state.loading = true
        },
        RMS_ACTIVE_ALARM_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
             state.alarms=action.payload.alarms
        },
           RMS_ACTIVE_ALARM_FETCH_LOAD_MORE: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.alarms=[...state.alarms,...action.payload.alarms]
        },
        RMS_ACTIVE_ALARM_FETCH_ERROR: (state) => {
            state.error = true
            state.loading = false
        }
    }
});

export const { RMS_ACTIVE_ALARM_FETCH_START, RMS_ACTIVE_ALARM_FETCH_SUCCESS, RMS_ACTIVE_ALARM_FETCH_ERROR,RMS_ACTIVE_ALARM_FETCH_LOAD_MORE } = RmsActiveAlarmSlice.actions;
export default RmsActiveAlarmSlice.reducer;